import { useResetPasswordMutation } from 'util/rtk-api'
import { useDocTitle } from 'util/hooks'

import React, { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import 'css/pages/reset-password.css'
import { showToast } from 'components/toast'
import { showMutationError } from 'util/mutation-error'

export const ResetPassword = () => {
	const searchParams = new URLSearchParams(window.location.search)
	const email = searchParams.get('email')
	const from = searchParams.get('from')
	const navigate = useNavigate()
	const [ resetPassword ] = useResetPasswordMutation()

	const [ code, setCode ] = useState()
	const [ password, setPassword ] = useState()

	const onCodeBlur = ({ target }) => {
		setCode(target.value)

		if (
			target.value.match(/\d{6}/)
		) {
			target.setCustomValidity('')
			return
		}

		target.setCustomValidity(
			'The pin should be a 6-digit number.'
		)
	}

	const onPasswordBlur = ({ target }) => {
		const conditions = [
			/.{8,}/,
			/[0-9]+/,
			/[a-z]+/,
			/[A-Z]+/,
			/[\^$*.[\]{}()?\-"!@#%&/\\,><':;|_~`+=]+/,
		]

		setPassword(target.value)

		if (
			conditions.every(pattern => target.value.match(pattern))
		) {
			target.setCustomValidity('')
			return
		}
		
		target.setCustomValidity(
			'The password must be at least 8 characters long and must use a lower case character, an upper case character, a number, and a special character.'
		)
	}

	const onConfirmPasswordBlur = ({ target }) => {
		if (target.value === password) {
			target.setCustomValidity('')
			return
		}

		target.setCustomValidity(
			'This does not match the password entered above'
		)
	}

	const onFormSubmit = async event => {
		event.preventDefault()

		const result = await resetPassword({ confirmationCode: code, username: email, password })

		if (showMutationError(result)) return

		showToast('Password reset successfully', 'success')
		navigate(`/success?from=${from || ''}`)
	}

	useDocTitle('All for One - Reset Password')

	return (
        <section className="reset-password-container">
            <h1 className="reset-password-header">Reset <span className="highlight">password</span></h1>

            <p className="reset-password-note">
			You’ll get an email at {email} if it’s linked to your account.
            </p>

            <form
				id="reset-password-form"
				action="#"
				method="POST"
				onSubmit={onFormSubmit}
			>
                <div className="form-group">
                    <input 
                        type="tel" 
                        id="code" 
                        name="code" 
                        placeholder="6-digit code" 
                        required
						onChange={({ target }) => setCode(target.value)}
						onBlur={onCodeBlur}
					/>
                </div>

				<input className="hidden-input"></input>

                <div className="form-group">
                    <input 
                        type="password" 
                        id="new-password" 
                        name="new-password" 
                        placeholder="New Password" 
                        required
						onChange={({ target }) => setPassword(target.value)}
						onBlur={onPasswordBlur}
					/>
                </div>

                <div className="form-group">
                    <input 
                        type="password" 
                        id="confirm-password" 
                        name="confirm-password" 
                        placeholder="Confirm New Password" 
                        required
						onBlur={onConfirmPasswordBlur}
					/>
                </div>

                <div className="form-group">
                    <button type="submit" className="reset-password-btn">Reset Password</button>
                </div>
            </form>

            <p className="login-prompt">
				<span>{from === 'settings'
					? 'Changed your mind?'
					: 'Remembered your password?'
				}</span>
				<Link
					to={from === 'settings' ? '/settings' : '/login'}
					className="login-link"
				>{from === 'settings'
					? 'Back to settings!'
					: 'Log in!'
				}</Link>
            </p>
        </section>
	)
}
